var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-2"},[_c('v-toolbar',{attrs:{"dense":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Welcome to your dashboard")]),_c('v-spacer')],1),_c('v-img',{attrs:{"src":require("@/assets/product_hero.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }